export const formStepsControlMixin = {
  data () {
    return {
      currentStep: 0,
      currentStepOld: 0,
    }
  },
  methods: {
    backStep() {
      this.currentStepOld = this.currentStep;
      this.currentStep = this.currentStep - 1;
    },
    forwardStep() {

      this.currentStepOld = this.currentStep;
      this.currentStep = this.currentStep + 1;
    },
  }
}


// WEBPACK FOOTER //
// ./src/templates/components/mixins/form-steps-control.js